<template>
    <div class="intro">
        <div id="pano"></div>
        <div class="introBoxOverray"></div>

        <div class="introBox">
            <img class="upperLogo iseoulu" :src="imgs.iseoulu" />
            <img class="upperLogo sitm2020" :src="imgs.sitm2020" />
            <div class="clear"></div>
            <img class="introDiagram" :src="intro_diagram" />
            <img class="introTitle" :src="intro_title" :style='titleStyle' />
            <div class="introMsgWrap">
                <div class="introMsg" v-html="intro_msg"></div>
                <button class="speakIcon" :class='speakIconClass' @click='onClickSpeakIcon()'>
                    <img :src="btn_clicked?imgs.speakBtn_active:imgs.speakBtn" :class='dynamicClassForNarrationIcon' />
                    <span :class='{playing: btn_clicked}'>{{ langPack('voice') }}</span>
                </button>
            </div>
            <button v-if='intro_btn_vr' class="introBtn" @click="onClickIntroBtn(intro_btn_vr, 'vr')">
                <img class="vr" :src="vrBtn" />
            </button>
            <button v-if='intro_btn_site' class="introBtn" @click="onClickIntroBtn(intro_btn_site)">
                <img class="site" :src="siteBtn" />
            </button>
        </div>
    </div>
</template>

<script>
import Iseoulu from "@/assets/logo/iseoulu.png";
import Sitm2020 from "@/assets/logo/sitm2020.png";
import Btn_speak from "@/assets/button/btn_speak.png";
import Btn_speak_active from "@/assets/button/btn_speaking.png";

import Btn_vrtour from "@/assets/button/kr/btn_vrtour.png";
import Btn_homepage from "@/assets/button/kr/btn_homepage.png";

import Btn_vrtour_en from "@/assets/button/en/btn_vrtour.png";
import Btn_homepage_en from "@/assets/button/en/btn_homepage.png";

import Btn_vrtour_cn from "@/assets/button/cn/btn_vrtour.png";
import Btn_homepage_cn from "@/assets/button/cn/btn_homepage.png";

import Btn_vrtour_jp from "@/assets/button/jp/btn_vrtour.png";
import Btn_homepage_jp from "@/assets/button/jp/btn_homepage.png";


import "animate.css/animate.css";

export default {
    props: {
        intro_diagram: String,
        intro_title: String,
        intro_msg: String,
        intro_scene: String,
        intro_btn_vr: String,
        intro_btn_site: String,
        intro_narration: String,
        intro_title_maxwidth: Number,
        lang: {
            type: String,
            default: 'kr',
        }
    },
    data() {
        return {
            imgs: {
                iseoulu: Iseoulu,
                sitm2020: Sitm2020,
                speakBtn: Btn_speak,
                speakBtn_active: Btn_speak_active,
            },
            langData: {
                kr: {
                    playing: '재생 중..',
                    voice: "음성안내",
                },
                en: {
                    playing: 'Playing..',
                    voice: "Voice",
                },
                jp: {
                    playing: 'Playing..',
                    voice: "音声ガイド",
                },
                cn: {
                    playing: 'Playing..',
                    voice: "语音提示",
                },
            },
            btn_clicked: false,
        };
    },
    mounted() {
        let loadXml = "vtour/main.xml";
        let embedpanoOption = {
            swf: "vtour/tour.swf",
            xml: loadXml,
            target: "pano",
            id: "vr",
            html5: "auto",
            mobilescale: 1.0,
            initvars: {},
            passQueryParameters: true,
            onready: this.onReadyKrpano,
        };
        embedpano(embedpanoOption);
    },
    computed: {
        dynamicClassForNarrationIcon(){
            return this.btn_clicked?'animate__animated animate__pulse animate__infinite':'';
        },
        titleStyle(){
            let style = {};
            if(this.intro_title_maxwidth){
                style['max-width'] = `${this.intro_title_maxwidth}px`;
            }
            return style;
        },
        speakIconClass(){
            let returnClass = {
                active: this.btn_clicked
            }
            returnClass[this.lang] = true;
            return returnClass;
        },
        vrBtn(){
            let btn;
            if(this.lang == 'kr'){
                btn = Btn_vrtour;
            }else if(this.lang == 'en'){
                btn = Btn_vrtour_en;
            }else if(this.lang == 'cn'){
                btn = Btn_vrtour_cn;
            }else if(this.lang == 'jp'){
                btn = Btn_vrtour_jp;
            }
            return btn;
        },
        siteBtn(){
            let btn;
            if(this.lang == 'kr'){
                btn = Btn_homepage;
            }else if(this.lang == 'en'){
                btn = Btn_homepage_en;
            }else if(this.lang == 'cn'){
                btn = Btn_homepage_cn;
            }else if(this.lang == 'jp'){
                btn = Btn_homepage_jp;
            }
            return btn;
        },
    },
    methods: {
        langPack(key){
            return this.langData[this.lang][key];
        },
        onReadyKrpano(krpano) {
            this.krpano = krpano;
        },
        // main.xml 의 onnewpano에서 실행.
        onKrpanoStartup() {
            if (this.intro_scene) {
                this.krpano.call(`loadscene(${this.intro_scene})`);
            }
        },
        onClickIntroBtn(url, type) {
            if(type == 'vr'){
                url += `?secretReferer=${encodeURIComponent(location.href)}`;
            }
            location.href = url;
        },
        onClickSpeakIcon(){
            if(!this.btn_clicked){
                if(this.krpano.get('sound[narration]')){
                    this.krpano.call(`sound[narration].play()`);
                }else{
                    this.krpano.call(`streamsound(narration, get(sitm_narration[${this.intro_narration}].url), false, 1)`)
                }
            }else{
                this.krpano.call(`sound[narration].pause()`);
            }
            this.btn_clicked = !this.btn_clicked;
        },
    },
};
</script>

<style scoped>
.intro {
    display: block;
    background-color: rgba(0, 0, 0, 0.904);
    padding: 0;
    height: 100%;
    overflow: auto;
    text-align: center;
    /* display: flex; */
    /* flex-direction: column; */
    /* height: calc(100% - 4em); */
}
.introBox {
    display: inline-block;
    position: relative;
    text-align: center;
    padding: 2em;
    max-width: 1200px;
    width: 100%;
}
@media (min-width: 1200px) {
    .introBox {
        padding : 3em;
    }
}
.introBox .upperLogo {
    width: 20vw;
    max-width: 10em;
    top: 2em;
}
.introBox .iseoulu {
    float: left;
}
.introBox .sitm2020 {
    float: right;
}
.introBox .introDiagram {
    width: 12vw;
    max-width: 120px;
    margin-right: 1em;
    margin-bottom: 2em;
    vertical-align: middle;
}
.introBox .introTitle {
    width: 50vw;
    max-width: 500px;
    min-width: 220px;
    margin-bottom: 3em;
    vertical-align: middle;
}
.introBox .introMsgWrap {
    position: relative;
}
.introBox .introMsgWrap .speakIcon {
    position: absolute;
    right: 0;
    top: 0;
    background: 0;
    border: 0;
    width: 15vw;
    max-width: 100px;
    min-width: 85px;
    transform: translate(20%, -50%);
    cursor: pointer;
}
.introBox .introMsgWrap .speakIcon:active {
    transform: translate(20%, -45%);
}
.introBox .introMsgWrap .speakIcon:focus {
    outline: 0;
}
.introBox .introMsgWrap .speakIcon img {
    width: 100%;
    margin-bottom: 1.25em;
    /* -webkit-filter: grayscale(50%);
    filter: grayscale(50%); */
}
.introBox .introMsgWrap .speakIcon:active img {
    width: 100%;
    /* -webkit-filter: grayscale(0%);
    filter: grayscale(0%); */
}
.introBox .introMsgWrap .speakIcon span {
    font-size: 1.2em;
    color: #000;
    background-color: #fff;
    border: 1px solid #fff;
    padding: 0.2em;
    border-radius: 5px;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
}
.introBox .introMsgWrap .speakIcon.jp span {
    font-size: 0.9em;
}
.introBox .introMsgWrap .speakIcon span.playing{
    color: #fff;
    background-color: #39B240;
}
.introBox .introMsg {
    border: 5px solid #fff;
    background-color: rgba(70, 70, 70, 0.8);
    color: #fff;
    padding: 3em 3em 1.5em 3em;
    font-size: 1.2em;
    margin-bottom: 2em;
}
@media only screen and (min-width: 900px) {
    .introBox .introMsg {
        padding: 4em 3em;
    }
}
.introBox .introBtn {
    margin: 0 1em;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    width: calc(40vw - 1em);
    max-width: 400px;
    min-width: 280px;
}
.introBox .introBtn:focus {
    outline: 0;
}
.introBox .introBtn img {
    width: 100%;
    -webkit-filter: grayscale(50%);
    filter: grayscale(50%);
}
.introBox .introBtn:active img {
    transform: translateY(4px);
    -webkit-filter: grayscale(0%);
    filter: grayscale(0%);
}
.introBox .clear {
    clear: both;
    margin-bottom: 1em;
}

#pano,
.introBoxOverray {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
}
.introBoxOverray {
    background-color: rgba(0, 0, 0, 0.7);
}

</style>